import moment from "moment";
export const dateField = {
  key2: "installDate",
  key3: "productPurchaseDate",
  key4: "coverageBeginDate",
  key5: "coverageEndDate",
  key6: "appointmentDate",
  key7: "consumerRequestDate",
};

const validateDate = (dateString) => {
  return moment(dateString).isValid() ? dateString : "";
};

export function validatePayloadDates(payload) {
  if (Array.isArray(payload)) {
    return payload.map((item) => validatePayloadDates(item));
  } else if (typeof payload === "object" && payload !== null) {
    Object.keys(payload).forEach((key) => {
      if (Object.values(dateField).includes(key)) {
        payload[key] = validateDate(payload[key]);
      } else if (typeof payload[key] === "object") {
        validatePayloadDates(payload[key]);
      }
    });
  }
  return payload;
}
